/* 三國逗陣打 · 舞台、場景與主迴圈 */
// @ts-nocheck — 第 2 步只把檔案改成模組，型別在第 4 步補
import { SG } from '../core/sg.ts';

const TAU = Math.PI * 2;
SG.stages = [];
SG.reduced = !!(window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches);

function mulberry(seed) {
  return function () {
    seed = (seed + 0x6d2b79f5) | 0;
    let t = Math.imul(seed ^ (seed >>> 15), 1 | seed);
    t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}

class Stage {
  constructor(canvas, W, H, o) {
    this.c = canvas; this.ctx = canvas.getContext('2d'); this.W = W; this.H = H; this.o = o || {};
    this.actors = []; this.props = []; this.fx = []; this.parts = []; this.tickers = []; this.timers = [];
    this.time = 0; this.shake = 0; this.running = !SG.reduced; this.visible = true; this.dirty = true; this.bgCache = null;
    canvas.style.aspectRatio = W + ' / ' + H;
    this.fit();
    if ('ResizeObserver' in window) new ResizeObserver(() => this.fit()).observe(canvas);
    if ('IntersectionObserver' in window) new IntersectionObserver((es) => { this.visible = es[es.length - 1].isIntersecting; }).observe(canvas);
    SG.stages.push(this);
  }
  add(a) { a.stage = this; this.actors.push(a); return a; }
  after(sec, fn) { this.timers.push({ t: sec, fn }); }
  refresh() { this.bgCache = null; this.dirty = true; }
  fit() {
    const cw = this.c.clientWidth;
    if (!cw) return;
    const dpr = Math.min(2, window.devicePixelRatio || 1);
    const w = Math.round(cw * dpr), h = Math.round(((cw * this.H) / this.W) * dpr);
    this.k = w / this.W;
    if (w !== this.c.width || h !== this.c.height) { this.c.width = w; this.c.height = h; this.bgCache = null; }
    this.dirty = true;
  }
  update(dt) {
    this.time += dt;
    for (const t of this.tickers) t(dt, this);
    this.timers = this.timers.filter((tm) => { tm.t -= dt; if (tm.t <= 0) { tm.fn(); return false; } return true; });
    for (const a of this.actors) a.update(dt);
    SG.updateFx(this, dt);
    this.shake = this.shake > 0.2 ? this.shake * Math.pow(0.002, dt) : 0;
  }
  render() {
    const ctx = this.ctx, k = this.k;
    if (!k) return;
    ctx.setTransform(1, 0, 0, 1, 0, 0); ctx.globalAlpha = 1; ctx.globalCompositeOperation = 'source-over';
    ctx.clearRect(0, 0, this.c.width, this.c.height);
    if (this.o.bg) {
      if (!this.bgCache) {
        const b = document.createElement('canvas'); b.width = this.c.width; b.height = this.c.height;
        const bx = b.getContext('2d'); bx.setTransform(k, 0, 0, k, 0, 0); this.o.bg(bx, this.W, this.H);
        this.bgCache = b;
      }
      ctx.drawImage(this.bgCache, 0, 0);
    }
    const sx = this.shake ? (Math.random() - 0.5) * this.shake : 0, sy = this.shake ? (Math.random() - 0.5) * this.shake * 0.6 : 0;
    ctx.setTransform(k, 0, 0, k, sx * k, sy * k);
    if (this.o.under) this.o.under(ctx, this);
    SG.drawFx(ctx, this, true);
    const T = this.time * 1000;
    const ents = this.actors.concat(this.props).sort((a, b) => a.y - b.y);
    for (const e of ents) e.draw(ctx, T);
    SG.drawFx(ctx, this, false);
    SG.drawParts(ctx, this);
    if (this.o.over) this.o.over(ctx, this);
  }
}
SG.Stage = Stage;

let last = 0;
function frame(now) {
  const dt = Math.min(0.05, (now - last) / 1000); last = now;
  // 全螢幕選將畫面蓋住時，底下的首頁動畫不用畫（IntersectionObserver 看不出被 fixed 圖層蓋住）
  if (!SG.covered) for (const s of SG.stages) {
    if (!s.visible) continue;
    if (s.running) s.update(dt);
    if (s.running || s.dirty) { s.render(); s.dirty = false; }
  }
  requestAnimationFrame(frame);
}
SG.start = () => requestAnimationFrame((n) => { last = n; frame(n); });

// ---------- 戰場背景（一次畫好快取） ----------
function ridge(ctx, W, hz, r, base, amp, col, fr) {
  const p1 = r() * 10, p2 = r() * 10, p3 = r() * 10;
  ctx.fillStyle = col; ctx.beginPath(); ctx.moveTo(0, hz);
  for (let x = 0; x <= W + 6; x += 6) {
    const y = base - amp * (0.55 * Math.abs(Math.sin(x * fr + p1)) + 0.3 * Math.sin(x * fr * 2.3 + p2) + 0.15 * Math.sin(x * fr * 5.1 + p3));
    ctx.lineTo(x, y);
  }
  ctx.lineTo(W, hz); ctx.closePath(); ctx.fill();
}
function ship(ctx, x, y, s, burning) {
  ctx.save(); ctx.translate(x, y); ctx.scale(s, s);
  if (burning) {
    const g = ctx.createRadialGradient(0, -14, 0, 0, -14, 30);
    g.addColorStop(0, 'rgba(255,160,70,.8)'); g.addColorStop(1, 'rgba(255,90,30,0)');
    ctx.fillStyle = g; ctx.fillRect(-30, -44, 60, 60);
    ctx.fillStyle = 'rgba(40,34,40,.35)'; ctx.beginPath(); ctx.ellipse(-6, -52, 9, 22, -0.3, 0, TAU); ctx.fill();
  }
  ctx.fillStyle = 'rgba(28,26,36,.85)';
  ctx.beginPath(); ctx.moveTo(-18, -4); ctx.lineTo(18, -4); ctx.lineTo(13, 2); ctx.lineTo(-14, 2); ctx.closePath(); ctx.fill();
  ctx.fillRect(-1, -26, 2, 22);
  ctx.beginPath(); ctx.moveTo(1, -25); ctx.lineTo(12, -22); ctx.lineTo(11, -8); ctx.lineTo(1, -7); ctx.closePath(); ctx.fill();
  ctx.restore();
}
function wavyBand(ctx, W, y0, y1, fill) {
  ctx.fillStyle = fill; ctx.beginPath(); ctx.moveTo(0, y0);
  for (let x = 0; x <= W + 40; x += 40) ctx.lineTo(x, y0 + Math.sin(x * 0.02) * 3);
  ctx.lineTo(W, y1);
  for (let x = W; x >= -40; x -= 40) ctx.lineTo(x, y1 + Math.sin(x * 0.017 + 1) * 3);
  ctx.closePath(); ctx.fill();
}

SG.paintField = function (ctx, W, H, o) {
  const r = mulberry(o.seed || 7), hz = o.horizon, rv = o.river || 26, gy = hz + rv, b1 = o.bands[0], b2 = o.bands[1];
  let g = ctx.createLinearGradient(0, 0, 0, hz);
  g.addColorStop(0, '#1b2238'); g.addColorStop(0.55, '#4b3d58'); g.addColorStop(1, '#d58c57');
  ctx.fillStyle = g; ctx.fillRect(0, 0, W, hz + 4);
  const sx = W * 0.64, sy = hz - 34;
  g = ctx.createRadialGradient(sx, sy, 0, sx, sy, 220);
  g.addColorStop(0, 'rgba(255,214,150,.55)'); g.addColorStop(1, 'rgba(255,170,110,0)');
  ctx.fillStyle = g; ctx.fillRect(0, 0, W, hz);
  ctx.fillStyle = '#ffe2b0'; ctx.beginPath(); ctx.arc(sx, sy, 24, 0, TAU); ctx.fill();
  // 遠山三層（墨暈）
  ridge(ctx, W, hz, r, hz - 70, 46, 'rgba(58,62,96,.55)', 0.004);
  ridge(ctx, W, hz, r, hz - 40, 38, 'rgba(40,44,70,.75)', 0.007);
  g = ctx.createLinearGradient(0, hz - 50, 0, hz);
  g.addColorStop(0, 'rgba(213,140,87,0)'); g.addColorStop(1, 'rgba(213,140,87,.35)');
  ctx.fillStyle = g; ctx.fillRect(0, hz - 50, W, 50);
  ridge(ctx, W, hz, r, hz - 14, 22, 'rgba(30,32,48,.9)', 0.012);
  // 長江與赤壁船影
  g = ctx.createLinearGradient(0, hz, 0, gy); g.addColorStop(0, '#b98767'); g.addColorStop(1, '#4b6170');
  ctx.fillStyle = g; ctx.fillRect(0, hz, W, rv);
  ctx.strokeStyle = 'rgba(255,220,180,.35)'; ctx.lineWidth = 1;
  for (let i = 0; i < 60; i++) { const x = r() * W, y = hz + 3 + r() * (rv - 5), l = 6 + r() * 20; ctx.beginPath(); ctx.moveTo(x, y); ctx.lineTo(x + l, y); ctx.stroke(); }
  for (let i = 0; i < (o.ships || 7); i++) ship(ctx, W * (0.08 + r() * 0.86), hz + 8 + r() * (rv - 12), 0.5 + r() * 0.45, i % 3 === 0);
  // 地面
  g = ctx.createLinearGradient(0, gy, 0, H); g.addColorStop(0, '#6d6a4c'); g.addColorStop(1, '#2f3324');
  ctx.fillStyle = g; ctx.fillRect(0, gy, W, H - gy);
  // 上路：江岸沙洲與蘆葦
  g = ctx.createLinearGradient(0, gy, 0, b1); g.addColorStop(0, '#8b7f5c'); g.addColorStop(1, '#6f6b4a');
  ctx.fillStyle = g; ctx.fillRect(0, gy, W, b1 - gy);
  ctx.fillStyle = 'rgba(60,80,90,.4)'; ctx.fillRect(0, gy, W, 4);
  ctx.lineCap = 'round';
  for (let i = 0; i < 150; i++) {
    const x = r() * W, y = gy + 3 + r() * 16, h = 8 + r() * 16;
    ctx.strokeStyle = r() < 0.5 ? '#a39a66' : '#6e6a45'; ctx.lineWidth = 1.2;
    ctx.beginPath(); ctx.moveTo(x, y); ctx.lineTo(x + (r() - 0.5) * 6, y - h); ctx.stroke();
  }
  // 中路：官道
  g = ctx.createLinearGradient(0, b1, 0, b2); g.addColorStop(0, '#7e6a48'); g.addColorStop(1, '#8e7750');
  wavyBand(ctx, W, b1 + 4, b2 - 2, g);
  ctx.strokeStyle = 'rgba(60,44,28,.35)'; ctx.lineWidth = 2;
  [0.35, 0.62].forEach((f) => {
    const y = b1 + (b2 - b1) * f;
    ctx.beginPath(); ctx.moveTo(0, y);
    for (let x = 0; x <= W; x += 30) ctx.lineTo(x, y + Math.sin(x * 0.013 + f * 9) * 2);
    ctx.stroke();
  });
  // 下路：林道
  g = ctx.createLinearGradient(0, b2, 0, H); g.addColorStop(0, '#4f5a38'); g.addColorStop(1, '#2c3322');
  wavyBand(ctx, W, b2 + 2, H + 10, g);
  for (let i = 0; i < 170; i++) {
    const x = r() * W, y = b2 + 8 + r() * (H - b2 - 8);
    ctx.strokeStyle = r() < 0.5 ? '#6f7d45' : '#3d4a2a'; ctx.lineWidth = 1.2;
    for (let j = -1; j <= 1; j++) { ctx.beginPath(); ctx.moveTo(x + j * 2, y); ctx.lineTo(x + j * 4, y - 5 - r() * 4); ctx.stroke(); }
  }
  // 散落：碎石與斷箭
  for (let i = 0; i < 60; i++) {
    ctx.fillStyle = 'rgba(140,133,112,.55)';
    ctx.beginPath(); ctx.ellipse(r() * W, gy + 10 + r() * (H - gy - 10), 1.5 + r() * 2.5, 1 + r() * 1.2, 0, 0, TAU); ctx.fill();
  }
  for (let i = 0; i < 24; i++) {
    const x = r() * W, y = gy + 14 + r() * (H - gy - 20), a = (-60 - r() * 40) * Math.PI / 180, l = 14 + r() * 8;
    const tx = x + Math.cos(a) * l, ty = y + Math.sin(a) * l;
    ctx.strokeStyle = '#3e3024'; ctx.lineWidth = 1.3; ctx.beginPath(); ctx.moveTo(x, y); ctx.lineTo(tx, ty); ctx.stroke();
    ctx.strokeStyle = '#d8d0bc'; ctx.lineWidth = 1;
    ctx.beginPath(); ctx.moveTo(tx, ty); ctx.lineTo(tx - 3, ty - 2); ctx.moveTo(tx, ty); ctx.lineTo(tx + 3, ty - 1); ctx.stroke();
  }
  // 前景矮叢
  ctx.fillStyle = 'rgba(22,26,18,.9)';
  for (let x = -20; x < W + 40; x += 30 + r() * 40) { const rr = 16 + r() * 24; ctx.beginPath(); ctx.arc(x, H + 8, rr, 0, TAU); ctx.fill(); }
};

// ---------- 城寨（塔） ----------
function flag(ctx, px, top, col, ch, T) {
  const w = 38, h = 28, ph = T * 0.004;
  const wave = (u) => Math.sin(ph + u * 4) * 3 * u;
  ctx.beginPath(); ctx.moveTo(px, top);
  for (let u = 0.2; u <= 1.001; u += 0.2) ctx.lineTo(px - w * u, top + wave(u));
  for (let u = 1; u >= -0.001; u -= 0.2) ctx.lineTo(px - w * u, top + h + wave(u) + u * 2);
  ctx.closePath(); SG.draw.ink(ctx, col, 1.8);
  ctx.fillStyle = '#f3e7cc'; ctx.font = '900 17px "Noto Serif TC", "Songti TC", serif'; ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
  ctx.fillText(ch, px - w * 0.5, top + h * 0.5 + wave(0.5) + 1);
}
function drawTower(ctx, tw, T) {
  const { caps, poly, dot, line, INK } = SG.draw;
  ctx.save(); ctx.translate(tw.x, tw.y); ctx.scale(tw.s, tw.s);
  SG.draw.castShadow(ctx, 0, 0, 50, 10, 200, 0.3);
  poly(ctx, [[-40, 0], [40, 0], [34, -20], [-34, -20]], '#6f6a64');
  ctx.strokeStyle = 'rgba(27,20,17,.5)'; ctx.lineWidth = 1;
  line(ctx, [-37, -10], [37, -10]);
  for (const x of [-20, 0, 20]) line(ctx, [x, -20], [x + 3, -10]);
  for (const x of [-28, -8, 12, 30]) line(ctx, [x, -10], [x - 2, 0]);
  caps(ctx, [
    [[-26, -20], [-23, -86], 4.5, '#5b3d27'], [[26, -20], [23, -86], 4.5, '#5b3d27'],
    [[-9, -20], [-8, -86], 4, '#4e3421'], [[9, -20], [8, -86], 4, '#4e3421'],
    [[-25, -30], [23, -78], 2.4, '#4e3421'], [[25, -30], [-23, -78], 2.4, '#4e3421'],
  ]);
  poly(ctx, [[-36, -84], [36, -84], [36, -110], [-36, -110]], '#7a5436');
  ctx.fillStyle = INK; for (const x of [-24, -8, 8, 24]) ctx.fillRect(x - 2, -103, 4, 12);
  caps(ctx, [[[-40, -84], [40, -84], 4, '#5b3d27']]);
  poly(ctx, [[-54, -106], [-44, -110], [-30, -132], [30, -132], [44, -110], [54, -106], [36, -112], [-36, -112]], '#2c303b');
  ctx.strokeStyle = 'rgba(120,130,150,.35)'; ctx.lineWidth = 1.2;
  for (let i = -4; i <= 4; i++) { ctx.beginPath(); ctx.moveTo(i * 7, -131); ctx.lineTo(i * 11.5, -111); ctx.stroke(); }
  ctx.strokeStyle = 'rgba(40,26,16,.45)'; ctx.lineWidth = 1;
  for (const y of [-92, -100]) { ctx.beginPath(); ctx.moveTo(-34, y); ctx.lineTo(34, y); ctx.stroke(); }
  caps(ctx, [[[-33, -133], [33, -133], 4.5, '#1f222a']]);
  dot(ctx, -35, -136, 3, '#1f222a', 1.4); dot(ctx, 35, -136, 3, '#1f222a', 1.4);
  tw.flags.forEach((fl, i) => {
    caps(ctx, [[[fl.x, -132], [fl.x, -196], 2.6, '#3a2a20']]);
    flag(ctx, fl.x, -194, fl.col, fl.ch, T + i * 400);
    dot(ctx, fl.x, -198, 2.4, '#d9b45c', 1.2);
  });
  ctx.restore();
}
SG.tower = (x, y, s, flags, team) => ({ kind: 'tower', x, y, s, flags, team, hp: 1, draw(ctx, T) { drawTower(ctx, this, T); } });

// ---------- 可投擲物 ----------
function drawProp(ctx, p) {
  const { poly, ink } = SG.draw;
  ctx.save(); ctx.translate(p.x, p.y); ctx.scale(p.s, p.s);
  ctx.fillStyle = 'rgba(10,8,6,.3)'; ctx.beginPath(); ctx.ellipse(0, 0, 12, 3.5, 0, 0, TAU); ctx.fill();
  if (p.kind === 'jar') {
    ctx.beginPath(); ctx.moveTo(-5, -22); ctx.quadraticCurveTo(-13, -18, -11, -8); ctx.quadraticCurveTo(-9, 0, 0, 0);
    ctx.quadraticCurveTo(9, 0, 11, -8); ctx.quadraticCurveTo(13, -18, 5, -22); ctx.closePath(); ink(ctx, '#7a4a2a');
    poly(ctx, [[-6, -25], [6, -25], [5, -21], [-5, -21]], '#b7a27a', 1.6);
    ctx.save(); ctx.translate(0, -12); ctx.rotate(Math.PI / 4); ctx.fillStyle = '#b53a2c'; ctx.fillRect(-5, -5, 10, 10); ctx.restore();
    ctx.fillStyle = '#1b1411'; ctx.font = '900 8px "Noto Serif TC", serif'; ctx.textAlign = 'center'; ctx.textBaseline = 'middle'; ctx.fillText('酒', 0, -12);
  } else {
    poly(ctx, [[-10, 0], [-11, -7], [-4, -12], [5, -11], [11, -5], [9, 0]], '#77736a', 1.8);
    ctx.strokeStyle = 'rgba(255,255,255,.25)'; ctx.lineWidth = 1.2; ctx.beginPath(); ctx.moveTo(-6, -8); ctx.lineTo(2, -10); ctx.stroke();
  }
  ctx.restore();
}
SG.prop = (kind, x, y, s) => ({ kind, x, y, s, draw(ctx) { drawProp(ctx, this); } });

// ---------- 頭上血條 ----------
SG.bar = function (ctx, x, y, v, col, label, w) {
  w = w || 46;
  ctx.save();
  ctx.fillStyle = 'rgba(16,20,28,.85)'; ctx.fillRect(x - w / 2 - 1.5, y - 1.5, w + 3, 8);
  ctx.fillStyle = col; ctx.fillRect(x - w / 2, y, w * v, 5);
  ctx.fillStyle = 'rgba(16,20,28,.6)'; for (let i = 1; i < 4; i++) ctx.fillRect(x - w / 2 + (w * i) / 4, y, 1, 5);
  if (label) {
    ctx.font = '700 12px "Noto Sans TC", "PingFang TC", sans-serif'; ctx.textAlign = 'center'; ctx.textBaseline = 'bottom';
    ctx.lineJoin = 'round'; ctx.lineWidth = 3; ctx.strokeStyle = 'rgba(16,20,28,.9)'; ctx.strokeText(label, x, y - 3);
    ctx.fillStyle = '#f3ead6'; ctx.fillText(label, x, y - 3);
  }
  ctx.restore();
};
